import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { PlaceForm, FiltersFormPlace } from 'civil-status/view-models/place';
import { DomainType } from 'civil-status/constants/domain';
import { MunicipalityValueDomainType, ValueDomainType } from 'shell/models/value-domain-type';
import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';

export const transformDataset = (values: FiltersFormPlace, idDominio: number): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    idDominio: {
      value: idDominio,
      operation: Operation.EQUALS,
    },
    idValore: {
      value: otherValues.id || '',
      operation: Operation.EQUALS,
    },
    descrizioneBreveValore: {
      value: otherValues.description || otherValues.name || '',
      operation: Operation.LIKE,
    },
    valore: {
      value: otherValues.surname || '',
      operation: Operation.LIKE,
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    codice: ordersToTransform.id,
    sede: ordersToTransform.description,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};

export const transformResponse = (
  response: AxiosResponse<HttpResponse<MunicipalityValueDomainType>>
): PlaceForm => {
  const valoreDominio = (response.data.payload.valoreDominio ||
    response.data.payload ||
    {}) as ValueDomainType;

  return {
    organization: valoreDominio?.key?.codEnte || '',
    code: valoreDominio?.key?.idValore || '',
    shortDescription: valoreDominio?.descrizioneBreveValore || '',
    completeDescription: valoreDominio?.valore || '',
    codeList: response.data.payload.comune ? '' : valoreDominio?.idValorePadre || '',
    municipality: response.data.payload.comune
      ? {
          id: valoreDominio?.idValorePadre,
          description: '',
          descriptionAnpr: response.data.payload.comune?.denominazione,
          province: response.data.payload.comune?.codiceSiglaProvincia,
        }
      : null,
    statisticCode: valoreDominio?.codiceStatistico || '',
    article: valoreDominio?.descrizioneArticoloAnteposto || '',
    gender: valoreDominio?.codiceGenere || '',
    orderNumber: valoreDominio?.numOrdinamento?.toString() || '',
    initialDate: valoreDominio?.dataInizioValidita
      ? DateTime.fromISO(valoreDominio?.dataInizioValidita)
      : null,
    finalDate: valoreDominio?.dataFineValidita
      ? DateTime.fromISO(valoreDominio?.dataFineValidita)
      : null,
  };
};

export const transformRequest = (
  values?: PlaceForm,
  idDominio?: number,
  tipoDominioPadre?: number
): ValueDomainType => {
  return {
    codiceGenere: values?.gender || undefined,
    codiceStatistico: values?.statisticCode || undefined,
    dataFineValidita: values?.finalDate ? values?.finalDate.toFormat('yyyy-MM-dd') : undefined,
    dataInizioValidita: values?.initialDate
      ? values?.initialDate.toFormat('yyyy-MM-dd')
      : undefined,
    descrizioneArticoloAnteposto: values?.article || undefined,
    descrizioneBreveValore: values?.shortDescription || undefined,
    idValorePadre: values?.municipality?.id || values?.codeList || undefined,
    tipoDominioPadre: tipoDominioPadre || DomainType.Municipality,
    key: {
      codEnte: values?.organization,
      idDominio,
      idValore: values?.code,
    },
    numOrdinamento: values?.orderNumber ? Number.parseInt(values.orderNumber, 10) : undefined,
    valore: values?.completeDescription || undefined,
  };
};
